export default __webpack_public_path__ + "static/media/github-original.fad4b944.svg";